import React from 'react';
import './ExecutiveSummaryCard.css';

function ExecutiveSummaryCard({ summary, changes, nextSteps }) {
  return (
    <div className="executive-summary-card">
      <h3>Executive Summary</h3>
      <div className="executive-summary-section">
        <span className="executive-summary-label">Overview</span>
        <p>{summary || 'No summary available yet.'}</p>
      </div>
      <div className="executive-summary-section">
        <span className="executive-summary-label">What Changed</span>
        <p>{changes || 'No material changes since the last review.'}</p>
      </div>
      <div className="executive-summary-section">
        <span className="executive-summary-label">What To Do Next</span>
        <ul>
          {(nextSteps?.length ? nextSteps : ['Coordinate with the IT vendor on top priorities.']).map(
            (item) => (
              <li key={item}>{item}</li>
            )
          )}
        </ul>
      </div>
    </div>
  );
}

export default ExecutiveSummaryCard;
